import React, { useRef } from "react";
import { array, func, object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";

import NavbarSearch from "../NavbarSearch";
import Navbar from "../Navbar";
import { Facebook, Instagram, InstagramOriginal, Pinterest, X } from "../../../atoms/icons/StoryPageIcons";
import YoutubeIcon from "../../footer/FooterIcons/YoutubeIcon";

import { STATIC_PAGE_LINKS } from "../../../../constants";
import { staticTexts } from "../../../utils/Translate";

import "./verticalMenubar.m.css";

const VerticalMenubar = ({ toggleVerticalMenubar, hamburgerMenu, publisherAttributes, pageType, section }) => {
  const ref = useRef(null);

  return (
    <div styleName="vertical-menubar-wrapper" className="vertical-menubar-wrapper">
      <div ref={ref} className="vertical-menubar preload" styleName="vertical-menubar slide-in">
        <div styleName="vertical-menubar-inner">
          <NavbarSearch
            publisherAttributes={publisherAttributes}
            closeBtn={false}
            toggleVerticalMenubar={toggleVerticalMenubar}
          />
          <Navbar
            menu={hamburgerMenu}
            toggleVerticalMenubar={toggleVerticalMenubar}
            dataTagCategory="Hamburger Menu"
            pageType={pageType}
            section={section}
            verticalNavbar
          />

          <div styleName="bottom-container">
            <span>{staticTexts().followUS}</span>
            <div styleName="social-share-icons">
              <Link href={STATIC_PAGE_LINKS.facebook} target="_blank" rel="noopener noreferrer">
                <Facebook width={48} height={48} />
                <Facebook color="#1877F2" width={48} height={48} />
              </Link>
              <Link href={STATIC_PAGE_LINKS.twitter} target="_blank" rel="noopener noreferrer">
                <X width={48} height={48} />
                <X color="#0F1419" width={48} height={48} />
              </Link>
              <Link href={STATIC_PAGE_LINKS.youtube} className="youtube-icon" target="_blank" rel="noopener noreferrer">
                <YoutubeIcon width={48} height={48} />
                <YoutubeIcon color="#FF0000" width={48} height={48} />
              </Link>
              <Link href={STATIC_PAGE_LINKS.instagram} target="_blank" rel="noopener noreferrer">
                <Instagram width={48} height={48} />
                <InstagramOriginal width={48} height={48} />
              </Link>
              <Link href={STATIC_PAGE_LINKS.pinterest} target="_blank" rel="noopener noreferrer">
                <Pinterest width={48} height={48} />
                <Pinterest color="#E60023" width={48} height={48} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

VerticalMenubar.propTypes = {
  toggleVerticalMenubar: func,
  hamburgerMenu: array,
  publisherAttributes: object,
  pageType: string,
  section: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  pageType: get(state, ["qt", "pageType"], ""),
});

export default connect(mapStateToProps, null)(VerticalMenubar);
